<template>
    <div class="p-6 pb-10 mb-15 shadow-md rounded-md">
        <h3 class="text-2xl font-bold">Restrictions</h3>
        <p class="text-base leading-5">
            Define restrictions for survey
        </p>
        <div class="mt-6">
            <form @submit.prevent="submit">
                <div class="lg:w-1/2">
                    <div class="custom-field mb-6">
                        <div>
                            <div class="flex text-sm mb-2">
                                <label class="flex items-center dark:text-gray-400">
                                    <jet-checkbox v-model:checked="form.properties.anytime_report">
                                        Anytime report download
                                    </jet-checkbox>
                                </label>
                            </div>
                            <div class="flex text-sm mb-2">
                                <label class="flex items-center dark:text-gray-400">
                                    <jet-checkbox v-model:checked="form.properties.reopen" value="reopen">
                                        Reopen
                                    </jet-checkbox>
                                </label>
                            </div>
                            <div class="flex text-sm mb-2">
                                <label class="flex items-center dark:text-gray-400">
                                    <jet-checkbox v-model:checked="form.properties.live_analytics" value="reopen">
                                        Show live analytics
                                    </jet-checkbox>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-between items-center">
                    <jet-action-message :on="form.recentlySuccessful" class="ml-auto mr-3">
                        Saved.
                    </jet-action-message>
                    <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" :bg-dark="true">
                        Save fields
                    </jet-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import JetCheckbox from "@/Jetstream/Checkbox";
import JetActionMessage from "@/Jetstream/ActionMessage";
import JetButton from '@/Jetstream/Button.vue'

export default {
    name: "SurveyPropertiesForm",
    components: {
        JetCheckbox,
        JetActionMessage,
        JetButton
    },
    props: {
        surveyType: {
            type: Number,
            required: true,
        },
        properties: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            form: this.$inertia.form({
                _method: 'PUT',
                surveyType: this.surveyType,
                properties: this.properties,
            }),
        }
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                }))
                .post(this.route('admin.survey.defaults.save'), {
                    errorBag: 'properties',
                    preserveScroll: true,
                })
        },
    }
}
</script>

<style scoped>

</style>
